import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddVendersRes;
export const AddVendersTodo = createAsyncThunk('AddVenders', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "POST",
            url: process.env.REACT_APP_API_URL + 'vendor_details',
            data: data ,
            headers: { "Content-Type": "multipart/form-data" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddVendersRes = res.data
        
    } catch (error) {
        return AddVendersRes = error.response.data
    }
})
